export interface Colors {
  [name: string]: Scheme
}

export interface Scheme {
  darkest?: string
  dark?: string
  darkestText?: string
  darkText?: string
  darkBorder?: string
  default?: string
  defaultLight?: string
  light?: string
  lightest?: string
  lite?: string
}

const colors: Colors = {
  gray: {
    darkest: 'bg-gray-darkest',
    dark: 'bg-gray-dark',
    darkestText: 'text-gray-darkest',
    darkText: 'text-gray-dark',
    darkBorder: 'border-gray-dark',
    light: 'bg-gray-light',
    lite: 'bg-gray-lite'
  },
  grayDisabled: {
    darkest: 'bg-gray-darkest',
    dark: 'bg-gray-dark',
    darkestText: 'text-gray-darkest',
    darkText: 'text-gray-dark',
    darkBorder: 'border-gray-dark',
    light: 'bg-gray-light',
    lite: 'bg-gray-lite'
  },
  blue: {
    darkest: 'bg-blue-darkest',
    dark: 'bg-blue-dark',
    darkestText: 'text-blue-darkest',
    darkText: 'text-blue-dark',
    darkBorder: 'border-blue-dark',
    default: 'bg-blue-default',
    defaultLight: 'bg-blue-defaultLight',
    light: 'bg-blue-light',
    lightest: 'bg-blue-lightest'
  },
  green: {
    darkest: 'bg-green-darkest',
    dark: 'bg-green-dark',
    darkestText: 'text-green-darkest',
    darkText: 'text-green-dark',
    darkBorder: 'border-green-dark',
    light: 'bg-green-light',
    lightest: 'bg-green-lightest'
  },
  red: {
    darkest: 'bg-red-darkest',
    dark: 'bg-red-dark',
    darkestText: 'text-red-darkest',
    darkText: 'text-red-dark',
    darkBorder: 'border-red-dark',
    light: 'bg-red-light',
    lightest: 'bg-red-lightest'
  },
  purple: {
    darkest: 'bg-purple-darkest',
    dark: 'bg-purple-dark',
    darkestText: 'text-purple-darkest',
    darkText: 'text-purple-dark',
    darkBorder: 'border-purple-dark',
    light: 'bg-purple-light',
    lightest: 'bg-purple-lightest'
  },
  orange: {
    darkest: 'bg-orange-darkest',
    dark: 'bg-orange-dark',
    darkestText: 'text-orange-darkest',
    darkText: 'text-orange-dark',
    darkBorder: 'border-orange-dark',
    light: 'bg-orange-light',
    lightest: 'bg-orange-lightest'
  },
  lochinvar: {
    darkest: 'bg-lochinvar-darkest',
    dark: 'bg-lochinvar-dark',
    darkestText: 'text-lochinvar-darkest',
    darkText: 'text-lochinvar-dark',
    darkBorder: 'border-lochinvar-dark',
    light: 'bg-lochinvar-light',
    lightest: 'bg-lochinvar-lightest'
  },
  prelude: {
    darkest: 'bg-prelude-darkest',
    dark: 'bg-prelude-dark',
    darkestText: 'text-prelude-darkest',
    darkText: 'text-prelude-dark',
    darkBorder: 'border-prelude-dark',
    light: 'bg-prelude-light',
    lightest: 'bg-prelude-lightest'
  },
  goldPurple: {
    darkest: 'bg-goldPurple-darkest',
    dark: 'bg-goldPurple-dark',
    darkestText: 'text-goldPurple-darkest',
    darkText: 'text-goldPurple-dark',
    darkBorder: 'border-goldPurple-dark',
    light: 'bg-goldPurple-light',
    lightest: 'bg-goldPurple-lightest'
  },
  manhattan: {
    darkest: 'bg-manhattan-darkest',
    dark: 'bg-manhattan-dark',
    darkestText: 'text-manhattan-darkest',
    darkText: 'text-manhattan-dark',
    darkBorder: 'border-manhattan-dark',
    light: 'bg-manhattan-light',
    lightest: 'bg-manhattan-lightest'
  },
  pigPink: {
    darkest: 'bg-pigPink-darkest',
    dark: 'bg-pigPink-dark',
    darkestText: 'text-pigPink-darkest',
    darkText: 'text-pigPink-dark',
    darkBorder: 'border-pigPink-dark',
    light: 'bg-pigPink-light',
    lightest: 'bg-pigPink-lightest'
  },
  downy: {
    darkest: 'bg-downy-darkest',
    dark: 'bg-downy-dark',
    darkestText: 'text-downy-darkest',
    darkText: 'text-downy-dark',
    darkBorder: 'border-downy-dark',
    light: 'bg-downy-light',
    lightest: 'bg-downy-lightest'
  },
  grandis: {
    darkest: 'bg-grandis-darkest',
    dark: 'bg-grandis-dark',
    darkestText: 'text-grandis-darkest',
    darkText: 'text-grandis-dark',
    darkBorder: 'border-grandis-dark',
    light: 'bg-grandis-light',
    lightest: 'bg-grandis-lightest'
  },
  matterhorn: {
    darkest: 'bg-matterhorn-darkest',
    dark: 'bg-matterhorn-dark',
    darkestText: 'text-matterhorn-darkest',
    darkText: 'text-matterhorn-dark',
    darkBorder: 'border-matterhorn-dark',
    light: 'bg-matterhorn-light',
    lightest: 'bg-matterhorn-lightest'
  },
  winterHazel: {
    darkest: 'bg-winterHazel-darkest',
    dark: 'bg-winterHazel-dark',
    darkestText: 'text-winterHazel-darkest',
    darkText: 'text-winterHazel-dark',
    darkBorder: 'border-winterHazel-dark',
    light: 'bg-winterHazel-light',
    lightest: 'bg-winterHazel-lightest'
  },
  regentStBlue: {
    darkest: 'bg-regentStBlue-darkest',
    dark: 'bg-regentStBlue-dark',
    darkestText: 'text-regentStBlue-darkest',
    darkText: 'text-regentStBlue-dark',
    darkBorder: 'border-regentStBlue-dark',
    light: 'bg-regentStBlue-light',
    lightest: 'bg-regentStBlue-lightest'
  },
  turquoise: {
    darkest: 'bg-turquoise-darkest',
    dark: 'bg-turquoise-dark',
    darkestText: 'text-turquoise-darkest',
    darkText: 'text-turquoise-dark',
    darkBorder: 'border-turquoise-dark',
    light: 'bg-turquoise-light',
    lightest: 'bg-turquoise-lightest'
  },
  pueblo: {
    darkest: 'bg-pueblo-darkest',
    dark: 'bg-pueblo-dark',
    darkestText: 'text-pueblo-darkest',
    darkText: 'text-pueblo-dark',
    darkBorder: 'border-pueblo-dark',
    light: 'bg-pueblo-light',
    lightest: 'bg-pueblo-lightest'
  },
  limeade: {
    darkest: 'bg-limeade-darkest',
    dark: 'bg-limeade-dark',
    darkestText: 'text-limeade-darkest',
    darkText: 'text-limeade-dark',
    darkBorder: 'border-limeade-dark',
    light: 'bg-limeade-light',
    lightest: 'bg-limeade-lightest'
  },
  peachCream: {
    darkest: 'bg-peachCream-darkest',
    dark: 'bg-peachCream-dark',
    darkestText: 'text-peachCream-darkest',
    darkText: 'text-peachCream-dark',
    darkBorder: 'border-peachCream-dark',
    light: 'bg-peachCream-light',
    lightest: 'bg-peachCream-lightest'
  },
  gorse: {
    darkest: 'bg-gorse-darkest',
    dark: 'bg-gorse-dark',
    darkestText: 'text-gorse-darkest',
    darkText: 'text-gorse-dark',
    darkBorder: 'border-gorse-dark',
    light: 'bg-gorse-light',
    lightest: 'bg-gorse-lightest'
  },
  bightSun: {
    darkest: 'bg-bightSun-darkest',
    dark: 'bg-bightSun-dark',
    darkestText: 'text-bightSun-darkest',
    darkText: 'text-bightSun-dark',
    darkBorder: 'border-bightSun-dark',
    light: 'bg-bightSun-light',
    lightest: 'bg-bightSun-lightest'
  },
  sun: {
    darkest: 'bg-sun-darkest',
    dark: 'bg-sun-dark',
    darkestText: 'text-sun-darkest',
    darkText: 'text-sun-dark',
    darkBorder: 'border-sun-dark',
    light: 'bg-sun-light',
    lightest: 'bg-sun-lightest'
  },
  white: {
    darkest: 'bg-white',
    dark: 'bg-white',
    darkestText: 'text-white',
    darkText: 'text-white',
    darkBorder: 'border-white',
    light: 'bg-white',
    lightest: 'bg-white'
  }
}

export default colors
